import { Camera, Shield, Clock, Activity } from 'lucide-react';
import clsx from 'clsx';

export default function ProfileCard({ profile, isEditing }) {
    return (
        <div className="bg-gradient-to-br from-primary-dark via-primary to-primary-light rounded-2xl p-6 text-white relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10">
                <div className="absolute top-0 right-0 w-40 h-40 bg-white rounded-full -translate-y-1/2 translate-x-1/2" />
                <div className="absolute bottom-0 left-0 w-32 h-32 bg-white rounded-full translate-y-1/2 -translate-x-1/2" />
            </div>

            <div className="relative z-10">
                {/* Avatar */}
                <div className="flex flex-col items-center text-center">
                    <div className="relative mb-4">
                        <div className="w-28 h-28 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-4xl font-bold border-4 border-white/30 shadow-xl">
                            {profile.name.split(' ').map(n => n[0]).join('')}
                        </div>
                        {isEditing && (
                            <button className="absolute bottom-1 right-1 p-2.5 bg-secondary text-white rounded-full hover:bg-secondary-dark transition-all shadow-lg hover:scale-105">
                                <Camera size={18} />
                            </button>
                        )}
                        {/* Online Indicator */}
                        <div className="absolute top-2 right-2 w-4 h-4 bg-success rounded-full border-2 border-white" />
                    </div>

                    <h2 className="text-2xl font-bold mb-1">{profile.name}</h2>
                    <p className="text-white/80 font-medium">{profile.role}</p>

                    {/* Role Badge */}
                    <div className="mt-3 px-4 py-1.5 bg-white/20 rounded-full text-sm font-medium backdrop-blur-sm">
                        <Shield size={14} className="inline mr-1.5" />
                        {profile.role}
                    </div>
                </div>

                {/* Stats */}
                <div className="grid grid-cols-3 gap-4 mt-6 pt-6 border-t border-white/20">
                    <div className="text-center">
                        <p className="text-2xl font-bold">12</p>
                        <p className="text-xs text-white/70">İnşaat</p>
                    </div>
                    <div className="text-center border-x border-white/20">
                        <p className="text-2xl font-bold">48</p>
                        <p className="text-xs text-white/70">Daire</p>
                    </div>
                    <div className="text-center">
                        <p className="text-2xl font-bold">156</p>
                        <p className="text-xs text-white/70">İşlem</p>
                    </div>
                </div>

                {/* Member Since */}
                <div className="mt-6 pt-4 border-t border-white/20 flex items-center justify-center gap-2 text-sm text-white/70">
                    <Clock size={14} />
                    <span>Üyelik: Ocak 2026</span>
                </div>
            </div>
        </div>
    );
}
